<template>
  <AppSection id="timesheet-cols" type="sub-section-1" :title="$t($getConst.pages.import_settings.invoice_cols_title)">
    <form class="my-3">
      <b-list-group class="text-capitalize mb-4">
        <b-list-group-item
          class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
          <b-row>
            <b-col cols="6">
              <b-form-group id="billing-term-category" :label="$t($getConst.pages.import_settings.billing_term_category)" label-for="billing_term_category">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="billing_term_category" size="lg" required
                              v-model.trim="$v.cols.invoices_billing_term_category.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_billing_term_category.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_billing_term_category"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="currency-code" :label="$t($getConst.pages.import_settings.currency)" label-for="currency">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="currency" size="lg" required
                              v-model.trim="$v.cols.invoices_currency.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_currency.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_currency"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="invoice-id" :label="$t($getConst.pages.import_settings.invoice_id)" label-for="invoice_id">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="invoice_id" size="lg" required
                              v-model.trim="$v.cols.invoices_invoice_id.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_invoice_id.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_invoice_id"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="billing-period" :label="$t($getConst.pages.import_settings.billing_period)" label-for="billing_period">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="billing_period" size="lg" required
                              v-model.trim="$v.cols.invoices_billing_period.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_billing_period.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_billing_period"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="statement-date" :label="$t($getConst.pages.import_settings.statement_date)" label-for="statement_date">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="statement_date" size="lg" required
                              v-model.trim="$v.cols.invoices_statement_date.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_statement_date.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_statement_date"/>
              </b-form-group>
            </b-col>
            <b-col cols="6" >
              <b-form-group id="payment-status" :label="$t($getConst.pages.import_settings.payment_status)" label-for="payment_status">
              <b-skeleton  type="input" class="mt-0 mb-3 h-75" v-if="is_loading"  ></b-skeleton>
                <b-form-input  v-else id="payment-status" size="lg" required
                               v-model.trim="$v.cols.invoices_payment_status.$model"
                               :class="{ 'is-invalid': $v.cols.invoices_payment_status.$error }">>
                  <AppFormFeedback  :errors="$v.invoices_payment_status"  />
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6"  >
              <b-form-group id="vendors-name" :label="$t($getConst.pages.import_settings.vendors_name)" label-for="vendors_name">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="vendors_name" size="lg" required
                              v-model.trim="$v.cols.invoices_vendors_name.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_vendors_name.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_vendors_name"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheets-sub-contractor-name" :label="$t($getConst.pages.import_settings.timesheets_sub_contractor_name)" label-for="timesheets_sub_contractor_name">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheets_sub_contractor_name" size="lg" required
                              v-model.trim="$v.cols.invoices_timesheets_sub_contractor_name.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_timesheets_sub_contractor_name.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_timesheets_sub_contractor_name"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheets-contractor-name" :label="$t($getConst.pages.import_settings.timesheets_contractor_name)" label-for="timesheets_contractor_name">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheets_contractor_name" size="lg" required
                              v-model.trim="$v.cols.invoices_timesheets_contractor_name.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_timesheets_contractor_name.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_timesheets_contractor_name"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheets-timesheet-week-end-date" :label="$t($getConst.pages.import_settings.timesheets_timesheet_week_end_date)" label-for="timesheets_timesheet_week_end_date">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheets_timesheet_week_end_date" size="lg" required
                              v-model.trim="$v.cols.invoices_timesheets_timesheet_week_end_date.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_timesheets_timesheet_week_end_date.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_timesheets_timesheet_week_end_date"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="payments-pay-code" :label="$t($getConst.pages.import_settings.payments_pay_code)" label-for="payments_pay_code">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="payments_pay_code" size="lg" required
                              v-model.trim="$v.cols.invoices_payments_pay_code.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_payments_pay_code.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_payments_pay_code"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheets-timesheet-id" :label="$t($getConst.pages.import_settings.timesheets_timesheet_id)" label-for="timesheets_timesheet_id">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheets_timesheet_id" size="lg" required
                              v-model.trim="$v.cols.invoices_timesheets_timesheet_id.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_timesheets_timesheet_id.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_timesheets_timesheet_id"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="payments-units" :label="$t($getConst.pages.import_settings.payments_units)" label-for="payments_units">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="payments_units" size="lg" required
                              v-model.trim="$v.cols.invoices_payments_units.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_payments_units.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_payments_units"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="payments-total-tax-amount" :label="$t($getConst.pages.import_settings.payments_total_tax_amount)" label-for="payments_total_tax_amount">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="payments_total_tax_amount" size="lg" required
                              v-model.trim="$v.cols.invoices_payments_total_tax_amount.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_payments_total_tax_amount.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_payments_total_tax_amount"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="payments-net-supplier-payable" :label="$t($getConst.pages.import_settings.payments_net_supplier_payable)" label-for="payments_net_supplier_payable">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="payments_net_supplier_payable" size="lg" required
                              v-model.trim="$v.cols.invoices_payments_net_supplier_payable.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_payments_net_supplier_payable.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_payments_net_supplier_payable"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="assignment-start-date" :label="$t($getConst.pages.import_settings.assignment_start_date)" label-for="assignment_start_date">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="assignment_start_date" size="lg" required
                              v-model.trim="$v.cols.invoices_assignment_start_date.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_assignment_start_date.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_assignment_start_date"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="assignment-end-date" :label="$t($getConst.pages.import_settings.assignment_end_date)" label-for="assignment_end_date">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="assignment_end_date" size="lg" required
                              v-model.trim="$v.cols.invoices_assignment_end_date.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_assignment_end_date.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_assignment_end_date"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheets-assignment-id" :label="$t($getConst.pages.import_settings.timesheets_assignment_id)" label-for="timesheets_assignment_id">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheets_assignment_id" size="lg" required
                              v-model.trim="$v.cols.invoices_timesheets_assignment_id.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_timesheets_assignment_id.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_timesheets_assignment_id"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="vendors-gp-id" :label="$t($getConst.pages.import_settings.vendors_gp_id)" label-for="vendors_gp_id">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="vendors_gp_id" size="lg" required
                              v-model.trim="$v.cols.invoices_vendors_gp_id.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_vendors_gp_id.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_vendors_gp_id"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="payments-project-id" :label="$t($getConst.pages.import_settings.payments_project_id)" label-for="payments_project_id">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="payments_project_id" size="lg" required
                              v-model.trim="$v.cols.invoices_payments_project_id.$model"
                              :class="{ 'is-invalid': $v.cols.invoices_payments_project_id.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.invoices_payments_project_id"/>
              </b-form-group>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>

      <AppConfirmButtons
        :submit-text="$getConst.pages.button.save"
        :cancel-text="$getConst.pages.button.cancel_changes"
        :isLoading="save_is_loading"
        @onSubmit="submit"
        @onCancel="resetData"
      />
    </form>
  </AppSection>
</template>


<script>
  import {required} from "vuelidate/lib/validators";
  import AppFormFeedback from "../../../../../components/common/form/AppFormFeedback";
  import AppConfirmButtons from "../../../../../components/common/utils/AppConfirmButtons";
  import {getCols,updateCols} from "../../../../../api/importSettings.api";
  import AppSection from "../../../../../components/common/sections/AppSection";


  export default {
    name: "timesheetCols",
    components: {AppSection, AppFormFeedback, AppConfirmButtons},
    props: {
      scope_id: null,
    },
    data() {
      return {
        cols:null,
        is_loading: false,
        save_is_loading: false,
      }
    },

    validations: {
      cols: {
        invoices_billing_term_category:{required},
        invoices_currency:{required},
        invoices_invoice_id:{required},
        invoices_billing_period:{required},
        invoices_statement_date:{required},
        invoices_vendors_name:{required},
        invoices_timesheets_sub_contractor_name:{required},
        invoices_timesheets_contractor_name:{required},
        invoices_timesheets_timesheet_week_end_date:{required},
        invoices_payments_pay_code:{required},
        invoices_timesheets_timesheet_id:{required},
        invoices_payments_units:{required},
        invoices_payments_total_tax_amount:{required},
        invoices_payments_net_supplier_payable:{required},
        invoices_assignment_start_date:{required},
        invoices_assignment_end_date:{required},
        invoices_timesheets_assignment_id:{required},
        invoices_vendors_gp_id:{required},
        invoices_payments_project_id:{required},
        invoices_payment_status:{required},
      }
    },

    methods: {
      isFormInvalid() {
        this.$v.$touch();
        return this.$v.$invalid;
      },
      submit() {
        if (this.isFormInvalid()) {
          return;
        }
        this.save_is_loading = true;
        updateCols(this.scope_id, this.cols).then(
          (response) => {
            this.cols = response.data;
            this.$snotify.success(this.$t(this.$getConst.pages.import_settings.columns_updated));
            this.save_is_loading = false;
          },
          error => {
            this.handleApiError(error);
            this.save_is_loading = false;
          }
        );

      },
      resetData() {
        this.getCols();
      },
      getCols() {
        this.is_loading = true;
        getCols(this.scope_id).then(
          response => {
            this.cols = response.data;
            this.is_loading = false;
          },
          error => {
            this.handleApiError(error);
            this.is_loading = false;
          }
        );
      },
    },
    created() {
      this.getCols();
    },
  }
</script>


<style scoped>

</style>
